<template>
    <div>
        <CRow>
            <CCol md="12" lg="12" xl="12" xxl="12" xs="12" sm="12">
                <CTableWrapper :items="data" :fields="fields" hover :striped="true" :border="true" small fixed
                    caption="Lista de Proyectos" icon="fas fa-coins" btn_name="Proyecto" @mtdBack="mtdBack"
                    @show_modal="mtd_open_modal" @action_edit="mtd_show" @action_delete="mtd_delete" :size="'md'"
                    :button_new="true" :actions="true" :withActions="'2%'" :buttonEdit="true" :buttonDelete="true" />
            </CCol>
        </CRow>

        <!-- modal -->
        <CModalForm :backdrop="true" :closeOnBackdrop="true" :size="'md'" :title="modal.title" :button="cp_button"
            :show.sync="modal.modal_form" @mtd_action="mtd_action" :color="'info'" :centered="true">
            <CRow>
                <CCol sm="12">
                    <CInput label="Nombre" placeholder="Digite nombre" v-model="project.name" />
                </CCol>
                <CCol sm="12">
                    <CInput label="Dirección" placeholder="Digite la dirección del proyecto" v-model="project.address"
                        type="text" />
                </CCol>
                <CCol sm="12">
                    <CInput label="Ubigeo" placeholder="Digite el ubigeo" v-model="project.ubigeo" type="text" />
                </CCol>
                <CCol sm="12">
                    <CTextarea label="Descripción" placeholder="Digite Descripción" v-model="project.description">
                    </CTextarea>
                </CCol>
                <CCol v-if="modal.action != 'store'" sm="12">
                    <label for="">Estado</label>
                    <CSwitchVue :key="componentKey" @changeSwitch="changeSwitch" class="mx-1 pl-2 pt-2"
                        :checked="project.state == 1 ? true : false" color="success" variant="opposite" shape="pill"
                        v-bind="labelIcon" />
                </CCol>
            </CRow>
        </CModalForm>

        <!-- modal delete -->
        <cModalDelete :backdrop="true" :closeOnBackdrop="true" :size="'md'" :title="'Borrar Proyecto'"
            :show.sync="modal_delete.boo" @mtd_commit="mtd_commit" :centered="true" :item="modal_delete.item" />
    </div>
</template>

<script>
const fields = [
    { key: "index", label: "Id", _style: "width:1%" },
    { key: "name", label: "Nombre", _style: "width:20%;" },
    { key: "address", label: "Dirección", _style: "width:20%;" },
    { key: "ubigeo", label: "Ubigeo", _style: "width:20%;" },
    { key: "description", label: "Descripción", _style: "width:20%;" },
    { key: "status", label: "Estado", _style: "width:5%;" },
];

import CTableWrapper from "../../../components/shared/datatable/Table.vue";
import CModalForm from "../../../components/shared/modals/cModalForm.vue";
import cModalDelete from "../../shared/modals/cModalDelete.vue";
import { mapActions } from "vuex";
import CSwitchVue from "../../shared/switch/CSwitch.vue";

export default {
    components: { CTableWrapper, CModalForm, cModalDelete, CSwitchVue },
    data() {
        return {
            prefix: "projects",
            fields,
            data: [],
            modal: {
                action: "",
                title: "",
                modal_form: false,
            },
            project: {
                id: "",
                name: "",
                address: "",
                ubigeo: "",
                description: "",
                campu_id: this.$store.getters.get_campu.id,
                state: 0,
            },
            modal_delete: {
                boo: false,
                item: [],
            },
            labelIcon: {
                labelOn: "\u2713",
                labelOff: "\u2715",
            },
            componentKey: 0,
        };
    },
    computed: {
        cp_button: function () {
            if (this.project.name) {
                return false;
            }
            return true;
        },
    },
    created() {
        this.mtd_getdata();
    },
    methods: {
        ...mapActions(["get", "post"]),
        mtd_getdata: function () {
            this.get({
                url: this.$store.getters.get__url + "/" + this.prefix + "/index/"+this.$store.getters.get_campu.id,
                token: this.$store.getters.get__token,
            })
                .then((response) => {
                    if (response.statusCode == 200) {
                        this.data = response.data;
                        let index = 1;
                        this.data.forEach((arr) => {
                            arr.Id = arr.id;
                            if (arr.state == 1) {
                                arr.status = "Activo";
                            } else {
                                arr.status = "Inactivo";
                            }
                            if (arr.address == null) {
                                arr.address = "sin dirección registrada";
                            }
                            arr.index = index;
                            index++;
                        })
                    }
                })
                .catch((errors) => {
                    console.log(errors);
                });
        },
        mtdBack: function () {
            this.$emit("mtdBack");
        },
        mtd_open_modal: function (boo, action) {
            this.modal.modal_form = boo;
            this.modal.action = action;
            action == "store"
                ? (this.modal.title = "Nuevo Proyecto")
                : (this.modal.title = "Editar Proyecto");
            action == "store"
                ? (this.project = {
                    id: "",
                    name: "",
                    address: "",
                    ubigeo: "",
                    description: "",
                    state: "",
                })
                : (this.project = { ...this.project });
            if (this.modal.action != "store") {
                this.componentKey += 1;
            }
        },
        mtd_show: function (id) {
            this.get({
                url: this.$store.getters.get__url + "/" + this.prefix + "/" + id + "/show",
                token: this.$store.getters.get__token,
            })
                .then((response) => {
                    this.project = response;
                    this.mtd_open_modal(true, "update");
                })
                .catch((errors) => {
                    console.log(errors);
                });
        },
        mtd_action: function () {
            this.post({
                url: this.$store.getters.get__url + "/" + this.prefix + "/" + this.modal.action,
                token: this.$store.getters.get__token,
                params: {
                    projects: this.project,
                    campu_id: this.$store.getters.get_campu.id,
                },
            })
                .then((response) => {
                    let color = "success";
                    let message = "";
                    if (response.data.state == 1) {
                        Swal.fire({
                            title: "Servicio ya resgistrado",
                            icon: "warning",
                        });
                    } else {
                        if (this.modal.action == "store") {
                            message = "REGISTRADO CORRECTAMENTE";
                        } else {
                            this.data.forEach((element) => {
                                if (element.Id == response.data.data.id) {
                                    element.Nombre = response.data.data.name;
                                    element.status = response.data.data.state;
                                }
                                message = "EDITADO CORRECTAMENTE";
                            });
                        }
                        this.project = {
                            id: "",
                            name: "",
                            address: "",
                            ubigeo: "",
                            description: "",
                            state: "",
                        };
                        this.mtd_getdata();
                        this.modal = {
                            action: "",
                            title: "",
                            modal_form: false,
                            name: "",
                        };
                        Swal.fire({
                            title: message,
                            icon: color,
                        });
                    }
                })
                .catch((errors) => {
                    Swal.fire({
                        title: errors,
                        icon: "danger",
                    });
                });
        },
        mtd_delete: function (item) {
            this.modal_delete.boo = true;
            this.modal_delete.item = item;
        },
        close_delete: function () {
            this.modal_delete.boo = false;
        },
        mtd_commit: function () {
            this.post({
                url: this.$store.getters.get__url + "/" + this.prefix + "/destroy",
                token: this.$store.getters.get__token,
                params: {
                    id: this.modal_delete.item.Id,
                },
            })
                .then((response) => {
                    this.mtd_getdata();
                    this.modal_delete = {
                        boo: false,
                        item: [],
                    };
                    Swal.fire({
                        title: "ELIMINADO CORRECTAMENTE",
                        icon: "success",
                    });
                })
                .catch((errors) => { });
        },
        changeSwitch: function (payload) {
            this.project.state = payload == true ? 1 : 0;
        },
    },
};
</script>

<style lang="scss" scoped>
.btn-search {
    color: #fff;
    background-color: #2819ae;
    border-color: #2517a3;
}
</style>